import React from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import AppBanner from "@/components/site/AppBanner";
import Hero from "@/components/site/Hero";
import Materials from "@/components/site/Materials";
import Services from "@/components/site/Services";
import Capabilities from "@/components/site/Capabilities";
import About from "@/components/site/About";
import PrisonReform from "@/components/site/PrisonReform";
import Locations from "@/components/site/Locations";
import Contact from "@/components/site/Contact";
import { useBrand } from "@/context/BrandContext";

const HomePage = () => {
  const { brand } = useBrand();

  React.useEffect(() => {
    document.title = `${brand.name} · ${brand.city}, ${brand.state}`;
  }, [brand]);

  return (
    <div data-testid={`home-${brand.slug}`}>
      <AppBanner />
      <Header />
      <main>
        <Hero />
        <Materials />
        <Services />
        <Capabilities />
        <About />
        <PrisonReform />
        <Locations />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
